import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { Container, Card, CardBody, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faEye, faFilePdf, faTimes } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import pdf1 from '../../assets/Shri_Dharam_Prakash.pdf';
const Awardees = () => {
 const [modal, setModal] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(null);

    const toggleModal = (district) => {
        setSelectedDistrict(district);
        setModal(!modal);
    };

    // Sample citation data - you can expand this with actual data
    const getCitationsForDistrict = (districtName) => {
        const citations = {
            "Ambala": [
            ],
            "Bhiwani": [
            ],
            "Charkhi Dadri": [
                { name: "Shri Dharam Prakash", pdf: pdf1 },
            ],
            "Fatehabad": [
            ],
            "Kurukshetra": [
            ],
            "Panipat": [
            ],
            "Rewari": [
            ],
            "Rohtak": [
            ],
            "Yamuna Nagar": [
            ]
        };
        return citations[districtName] || [];
    };

    const districts = [
        { name: "Ambala", count: 0 },
        { name: "Bhiwani", count: 0 },
        { name: "Charkhi Dadri", count: 1 },
        { name: "Faridabad", count: 0 },
        { name: "Fatehabad", count: 0 },
        { name: "Gurugram", count: 0 },
        { name: "Hisar", count: 0 },
        { name: "Jhajjar", count: 0 },
        { name: "Jind", count: 0 },
        { name: "Kaithal", count: 0 },
        { name: "Karnal", count: 0 },
        { name: "Kurukshetra", count: 0 },
        { name: "Narnaul", count: 0 },
        { name: "Nuh", count: 0 },
        { name: "Palwal", count: 0 },
        { name: "Panchkula", count: 0 },
        { name: "Panipat", count: 0 },
        { name: "Rewari", count: 0 },
        { name: "Rohtak", count: 0 },
        { name: "Sirsa", count: 0 },
        { name: "Sonepat", count: 0 },
        { name: "Yamuna Nagar", count: 0 }
    ];
    

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faMedal} className="me-2" />
                        Gallantry Awardees
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faMedal} className="me-2" />
                            District-wise Gallantry Awardees
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="table-responsive">
                            <Table bordered hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Sr. No.</th>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '40%' }}>District</th>
                                        <th style={{ background: '#16a085', color: 'white', width: '15%' }}>Count</th>
                                        <th style={{ background: '#8e44ad', color: 'white', width: '35%' }}>Citations</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {districts.map((district, index) => (
                                        <tr key={district.name}>
                                            <td style={{ color: '#495057' }}>{index + 1}</td>
                                            <td style={{ color: '#1e3c72', fontWeight: '600' }}>{district.name}</td>
                                            <td>
                                                <Link 
                                                    to={`/awards-capf/${district.name}`}
                                                    style={{
                                                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                                        color: 'white',
                                                        textDecoration: 'none',
                                                        fontSize: '14px', 
                                                        fontWeight: '600',
                                                        borderRadius: '20px',  
                                                        padding: '8px 20px', 
                                                        display: 'inline-block',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                                        e.currentTarget.style.transform = 'scale(1.05)';
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                    {district.count}
                                                </Link>
                                            </td>
                                            <td>
                                                {getCitationsForDistrict(district.name).length > 0 ? (
                                                    <button 
                                                        onClick={() => toggleModal(district.name)}
                                                        style={{
                                                            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '8px 20px',
                                                            borderRadius: '20px',
                                                            fontSize: '14px',
                                                            fontWeight: '600',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.3s',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            width: window.innerWidth < 768 ? '100%' : '50%'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                                            e.currentTarget.style.transform = 'scale(1.05)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)';
                                                            e.currentTarget.style.transform = 'scale(1)';
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faEye} />
                                                        View Citations
                                                    </button>
                                                ) : (
                                                    <span style={{ color: '#6c757d' }}>-</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        
            {/* Modal for Citations */}
            <Modal isOpen={modal} toggle={() => toggleModal(null)} size="lg" centered>
                <ModalHeader 
                    toggle={() => toggleModal(null)}
                    style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        color: 'white',
                        border: 'none'
                    }}
                >
                    <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                    Citations for District {selectedDistrict}
                </ModalHeader>
                <ModalBody className="p-4">
                    {selectedDistrict && getCitationsForDistrict(selectedDistrict).length > 0 ? (
                        <div>
                            <ul className="list-unstyled">
                                {getCitationsForDistrict(selectedDistrict).map((citation, index) => (
                                    <li key={index} className="mb-3">
                                        <a 
                                            href={citation.pdf} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#1e3c72',
                                                textDecoration: 'none',
                                                fontSize: '16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '15px 20px',
                                                border: '1px solid #e9ecef',
                                                borderRadius: '10px',
                                                backgroundColor: '#f8f9fa',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.backgroundColor = '#1e3c72';
                                                e.currentTarget.style.color = 'white';
                                                e.currentTarget.style.borderColor = '#1e3c72';
                                                e.currentTarget.style.transform = 'translateX(5px)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                e.currentTarget.style.color = '#1e3c72';
                                                e.currentTarget.style.borderColor = '#e9ecef';
                                                e.currentTarget.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faFilePdf} className="me-3" style={{ color: '#dc3545', fontSize: '1.3rem' }} />
                                            <span className="flex-grow-1">{citation.name}</span>
                                            <FontAwesomeIcon icon={faEye} />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="text-muted">No citations available for {selectedDistrict} district.</p>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
                    <Button 
                        style={{
                            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 25px',
                            fontWeight: '600'
                        }} 
                        onClick={() => toggleModal(null)}
                    >
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Awardees;
